import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appCopyTableDetails]',
  standalone: true,
  host: {
    '(click)': 'onClick()'
  }
})
export class CopyTableDetailsDirective {

  @Input('appCopyTableDetails') tableEl: HTMLTableElement;

  public onClick(): void {
    if (this.tableEl) {
      let result = '';

      this.tableEl.querySelectorAll('tr').forEach(r => {
        const cells = r.querySelectorAll('td');

        if (cells.length > 1) {
          const label = cells[0].textContent?.trim().replace(':', '') ?? '';
          const value = cells[1].textContent?.trim() ?? '';

          if (label && value) {
            result += `${label}: ${value}\n`;
          }
        }
      });

      navigator.clipboard.writeText(result);
    }
  }
}
